import { Subscription } from 'interfaces/system';

export function formatSubscriptionStatus(
  loadingSubscription: boolean,
  subscription: Subscription,
) {
  let isSubscriptionInactive = false;
  let isOnHold = false;
  let isTrial = false;
  let isActive = false;

  if (!loadingSubscription) {
    if (
      subscription.status === 'not-found' ||
      subscription.status === 'inactive'
    ) {
      isSubscriptionInactive = true;
    }

    if (subscription.status === 'on-hold') {
      isOnHold = true;
    }

    if (subscription.status === 'active' && subscription?.type === 'trial') {
      isTrial = true;
    }
    if (
      subscription.status === 'active' &&
      subscription?.billing_period !== 'trial'
    ) {
      isActive = true;
    }
  }
  return { isSubscriptionInactive, isOnHold, isTrial, isActive };
}
